import React from "react";
import { Unity } from "react-unity-webgl";

const UnityCanvas = ({ unityProvider, cursorStyle, playerOffset }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: `${playerOffset}px`,
        width: `calc(100% - ${playerOffset}px)`,
        height: "100%",
      }}
    >
      <Unity
        unityProvider={unityProvider}
        style={{
          width: "100%",
          height: "100%",
          cursor: cursorStyle,
          mt: "50px",
        }}
        devicePixelRatio={window.devicePixelRatio}
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default UnityCanvas;
